module.exports = __webpack_public_path__ + "static/media/palette-412w.f4cbf123.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project_pictures/palette-412w.jpg
// module id = 29
// module chunks = 0